__webpack_require__.p = "/voc-banner-revamp/system-email-templates/";